export { default } from './CicDisclosureDocumentLink';
